import React from 'react'

import { ModalBase } from '@components/atoms'
import { useAppSelector } from '@store/hooks'

export const ModalBlackFriday = () => {
	const {
		modal: { modalName },
	} = useAppSelector((state) => state)

	return (
		<ModalBase
			title=''
			open={modalName === 'blackFriday'}
			variant='blackFridayImage'
		>
			<></>
		</ModalBase>
	)
}
